const resizeImage = function (img, maxSize) {
  return new Promise((resolve, reject) => {
    if (img) {
      try {
        var image = new Image();
        image.onload = () => {
          // Resize the image
          var canvas = document.createElement('canvas'),
          max_size = Number(maxSize) || 1024,
          width = image.width,
          height = image.height;
          if (width > height) {
              if (width > max_size) {
                  height *= max_size / width;
                  width = max_size;
              }
          } else {
              if (height > max_size) {
                  width *= max_size / height;
                  height = max_size;
              }
          }
          canvas.width = width;
          canvas.height = height;
          canvas.getContext('2d').drawImage(image, 0, 0, width, height);
          var resizedImage = canvas.toDataURL('image/jpeg');
          resolve(resizedImage)
        }
        image.src = img;
      } catch (error) {
        console.log(error);
        reject(error)
      }
    } else {
      console.log('Image is undefined');
      reject()
    }
  })
}

export default resizeImage;